export const NAVIGATE_AIF_SIGNUP_URL = 'https://accreditation.navigateaif.co.in/#/sign-up';

// noopener/noreferrer so the partner portal cannot reach back through
// window.opener into the investor's session.
export const openNavigateAifSignUp = (): void => {
  window.open(NAVIGATE_AIF_SIGNUP_URL, '_blank', 'noopener,noreferrer');
};
